import React from 'react';
import './App.css';
import Pages from './Pages.js';


function App() {
  return (
    <html className="Html">

      <div className="App">

        <div class="topnav">



        </div>
        <Pages />
      </div>
    </html>
  );
}

export default App;
